import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from "@mui/material";

const ActivityLogSkeleton: React.FC = () => (
  <Box>
    <Box
      sx={{
        // height: "400px",
        backgroundColor: "white",
        borderRadius: "5px",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
      }}
    >
      <Skeleton
        variant="text"
        width={150}
        height={24}
        sx={{
          position: "sticky",
          top: 0,
          px: 2,
          py: 1,
          borderBottom: "1px solid #e0e0e0",
          backgroundColor: "white",
          zIndex: 1,
        }}
      />
      <TableContainer
        sx={{
          // height: "350px",
          overflow: "auto",
          borderWidth: 0,
          elevation: 0,
          borderRadius: 0,
          boxShadow: 0,
        }}
        component={Paper}
        elevation={0}
      >
        <Table>
          <TableBody>
            {[...Array(2)].map((_, index) => (
              <TableRow key={index}>
                <TableCell sx={{ border: "none", py: 1.3 }}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      flexWrap="wrap"
                      gap={0.5}
                    >
                      <Skeleton variant="circular" width={18} height={18} />
                      <Skeleton variant="text" width={80} height={14} />
                      <Skeleton variant="text" width="60%" height={16} />
                    </Box>
                    <Skeleton
                      variant="text"
                      width={100}
                      height={12}
                      sx={{ mt: 0.5, ml: 0.5 }}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  </Box>
);

export default ActivityLogSkeleton;
